import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-js-day2',
  templateUrl: './js-day2.component.html',
  styleUrls: ['./js-day2.component.css']
})
export class JsDay2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
